const onboarding = {
  businessLogic: {
    title: 'היגיון עסקי',

    areasOfOpertaion: {
      title: 'אזורים לפעילות',
      subTitle: 'הראה לנו היכן אתה פועל. בחר עיר שלמה\nמדינה או סתם שכונה\nזה תלוי בך.',
      hideLightZones: 'הדגש אזורים',
    },

    operationPreferences: {
      title: 'העדפות תפעול',
      subTitle: 'עזור לנו להכיר אותך טוב יותר.',

      form: {
        sections: {
          operationPrefernces: {
            header: 'מהן העדפות התפעול שלך?',
            operationPreferncesOptions: {
              singleRides: 'נסיעות יחיד',
              sharedRides: 'נסיעות משותפות',
            },
          },

          routingSettings: {
            header: 'הגדרות הפקה',
            info: 'משך מקסימלי: משך מקסימלי של נסיעה. עצירות מקסימליות: מקסימום עצירות בנסיעה. יחס: 1.5 פירושו שמשך הזמן של אדם היושב ברכב לא יעלה על 150% מהזמן שהיה מבלה בנהיגה לבד. מקסימום נוסעים - מספר המושבים המקסימלי לנסיעה.',

            fields: {
              maxDuration: 'משך מקסימלי',
              paxAtOnce: 'מספר נוסעים בו-זמנית',
              maxStops: 'מקסימום עצירות',
              jobsAtOnes: 'עבודות בו-זמנית',
              maxPassengers: 'מקסימום נוסעים',
              rate: 'תעריף',
              pickAll: 'בחר הכל',
            },
          },

          pickSettings: {
            header: 'הגדרות בחירה',
            info: 'משך מקסימלי: משך מקסימלי של נסיעה. עצירות מקסימליות: מקסימום עצירות בנסיעה. יחס: 1.5 פירושו שמשך הזמן של אדם היושב ברכב לא יעלה על 150% מהזמן שהיה מבלה בנהיגה לבד. מקסימום נוסעים - מספר המושבים המקסימלי לנסיעה.',

            fields: {
              ambulatory: 'אמבולטורי (דקות)',
              wheelchair: 'כיסא גלגלים (דקות)',
              maxEarly: 'הקדמה מקסימלית (דקות)',
              maxLate: 'איחור מקסימלי (דקות)',
            },
          },

          dropSettings: {
            header: 'הגדרות הורדה',
            info: 'משך מקסימלי: משך מקסימלי של נסיעה. עצירות מקסימליות: מקסימום עצירות בנסיעה. יחס: 1.5 פירושו שמשך הזמן של אדם היושב ברכב לא יעלה על 150% מהזמן שהיה מבלה בנהיגה לבד. מקסימום נוסעים - מספר המושבים המקסימלי לנסיעה.',

            fields: {
              ambulatory: 'אמבולטורי (דקות)',
              wheelchair: 'כיסא גלגלים (דקות)',
              maxEarly: 'הקדמה מקסימלית (דקות)',
              maxLate: 'איחור מקסימלי (דקות)',
            },
          },
        },
      },
    },

    fleetDefenition: {
      title: 'הגדרת צי',
      subTitle: 'עכשיו, Lets talk fleet. Almost Done!',

      form: {
        sections: {
          assignmentPreferences: {
            header: 'מהן העדפות ציוות הנהגים הכלליות שלך?',
            fields: {
              defaultCarLocation: 'מיקום רכב ברירת מחדל (כתובת)',
              maxDuration: 'משך מקסימלי למשמרת (דקות)',
            },
            assignmenOptions: {
              leastVehicles: 'מספר מינימלי <br/> של רכבים',
              balacedVehicles: 'הפקה מאוזנת',
            },
          },

          vehiclesAndDrivers: {
            header: 'כמה רכבים ונהגים יש?',
            vehicles: 'רכבים',
            drivers: 'נהגים',

            quickEntry: {
              header: 'הזנה מהירה',
              fields: {
                numberOfVehicles: 'מספר רכבים',
                wheelChairVehicles: 'רכבים לכיסאות גלגלים',
                numberOfDrivers: 'מספר נהגים',
                wheelChairDrivers: 'נהגים לכיסאות גלגלים',
              },
            },

            files: {
              header: 'אנא ציין את מיקומי הכניסה והיציאה שלך',
              explanation: 'הסבר על מה בדיוק זה אומר. הסבר ועוד הסבר וזה עשוי להספיק.',
              example: 'Please make sure to address all attributes properly. ',
              exampleFileText: 'לתוצאה הטובה ביותר אל תהסס להשתמש ב',
              exampleFile: 'קובץ דוגמה',
              trySampleText: 'No data? ',
              trySampleBtn: 'נסה דוגמה.',
            },

            uploadData: {
              header: 'העלאת נתונים',
              firstLine: 'אנא ודא שכל המאפיינים מטופלים. לתוצאות הטובות ביותר אל תהסס להשתמש ב',
              secondLine: {
                firsTpart: 'אנא ודא שכל המאפיינים מטופלים כראוי. לתוצאות הטובות ביותר',
                vehicle: 'קובץ דוגמה של רכבים',
                and: 'ו',
                drivers: 'קובץ דוגמה של נהגים',
              },
            },
          },
        },
      },
    },

    scheduleAutomation: {
      title: 'אוטומציית תזמון',
      subTitle: 'עזור לנו להכיר אותך טוב יותר.',
    },

    additionalFeatures: {
      title: 'תכונות נוספות',
      subTitle: 'ככל שנדע יותר נוכל לספק שירות טוב יותר.',

      form: {
        file: {
          header: 'אנא ציין את מיקומי הכניסה והיציאה שלך',
          explanation: 'הסבר על מה בדיוק זה אומר. הסבר ועוד הסבר וזה עשוי להספיק.',
          example: 'Please make sure to address all attributes properly. ',
          exampleFileText: 'לתוצאה הטובה ביותר אל תהסס להשתמש ב',
          exampleFile: 'קובץ דוגמה',
          trySampleText: 'No data? ',
          trySampleBtn: ' Try a sample.',
        },

        willCall: {
          header: 'האם ברצונך להפעיל את אפשרות "Will Call"?',
          info: 'משך מקסימלי: משך מקסימלי של נסיעה. עצירות מקסימליות: מקסימום עצירות בנסיעה. יחס: 1.5 פירושו שמשך הזמן של אדם היושב ברכב לא יעלה על 150% מהזמן שהיה מבלה בנהיגה לבד. מקסימום נוסעים - מספר המושבים המקסימלי לנסיעה.',
          on: 'בתאריך',
          off: 'כבוי',
          time: 'זמן',
          attribute: 'מאפיין',
          explanation: 'אנא ודא שאתה מטפל במאפיין זה בקבצי הביקוש שלך',
        },
      },
    },
  },

  assets: {
    title: 'נכסים',
    fleetDefinition: {
      title: 'הגדרת צי',
      subTitle: 'עכשיו, Lets talk fleet. Almost Done!',
    },
  },

  demand: {
    title: 'ביקוש',

    dataUpload: {
      title: 'העלאת נתונים',
      subTitle: 'הזן אותי בביקוש ואנו מוכנים לצאת לדרך!',

      form: {
        file: {
          explanation: 'Please make sure to address all attributes properly. For the best result feel ',
          example: 'אנא ודא שכל המאפיינים מטופלים כראוי. לתוצאות הטובות ביותר',
          exampleFile: 'קובץ דוגמה',
          trySampleText: 'אין נתונים?',
          trySampleBtn: 'נסה דוגמה.',
        },
      },
    },
  },

  save: 'הבא',

  kpi: {
    title: 'שלבים הושלמו',
    wellDone: 'כל הכבוד!',
    labels: {
      onboardingKpiCompleted: 'הושלם',
    },
  },

  submit: {
    text: 'וזהו זה! אנחנו מוכנים. אם אתה מרוצה מהתשובות שלך ולא רוצה לשנות דבר, המשך ליצור את התרחיש המותאם אישית שלך.',
    create: 'הוסף תרחיש חדש',
  },
};

export default onboarding;
